import router from 'next/router';
import { useEffect } from 'react';
import { removeCookie, setCookie } from 'src/utils/cookie';
import { collectRwgConversion } from 'src/utils/rwg';

// https://developers.google.com/actions-center/verticals/appointments/redirect/integration-steps/conversion-tracking
// クエリパラメータに rwg_token が含まれる場合に cookie に保存する
export const useRwgConversionTrackingToken = () => {
  useEffect(() => {
    removeCookie('rwg_token'); // 前回のトークンが影響しないように消しておく

    const rwgToken = router.query.rwg_token;
    if (typeof rwgToken === 'string') {
      setCookie('rwg_token', rwgToken, null, { maxAgeInDays: 30 });
    }
  }, []);
};

export const useCollectRwgConversion = () => {
  useEffect(() => {
    collectRwgConversion();
  }, []);
};
